<template>
  <v-card class="pa-md-5 mt-3" elevation="3">
    <v-img :src="picture" alt="rank" class="badge"></v-img>
    <v-card-title>
      <v-flex xs2>
        <v-img :src="Sponsor.logo" :alt="Sponsor.name"></v-img>
      </v-flex>
      <v-flex v-if="Sponsor.showName" mx-5 display-1>{{ Sponsor.name }}</v-flex>
    </v-card-title>
    <v-card-text ma-0>
      <v-flex>
        <Edit
          :text="Sponsor.text"
          :syncText="syncText"
          title="Edit Description"
        ></Edit>
      </v-flex>
    </v-card-text>
  </v-card>
</template>

<script>
import Edit from "../Edit";

export default {
  props: ["Sponsor", "syncText"],
  components: { Edit },
  computed: {
    picture() {
      if (this.Sponsor && this.Sponsor.bespoke) {
        if (this.Sponsor.rank === "Gold") {
          return require("@/assets/images/icons/gold_bespoke.png");
        } else if (this.Sponsor.rank === "Silver") {
          return require("@/assets/images/icons/silver_bespoke.png");
        } else if (this.Sponsor.rank === "Bronze") {
          return require("@/assets/images/icons/bronze_bespoke.png");
        } else {
          return "";
        }
      } else {
        return "";
      }
    }
  }
};
</script>

<style scoped>
.badge {
  position: absolute;
  width: 40px;
  right: -10px;
  top: -10px;
}
</style>